module.exports = __webpack_public_path__ + "img/a.-philip-randolph.13ee4bd8.png";